// Copyright (c) 2017 Deere & Company

import BusyCounter, {getDefaultState as getBusyCounterDefaultState} from '../../../shared/state/busy-counter';
import LaborRate, {getDefaultState as getLaborRateDefaultState} from '@deere/cps-it.warranty-model-factory/lib/labor-rate';
import t from 'tcomb';

const State = t.struct({
    busyCounter: BusyCounter,
    isConfirmationModalVisible: t.Boolean,
    isSubmitDisabled: t.Boolean,
    laborRate: LaborRate
}, 'State');

export const getDefaultState = () =>
    new State({
        busyCounter: getBusyCounterDefaultState(),
        isConfirmationModalVisible: false,
        isSubmitDisabled: true,
        laborRate: getLaborRateDefaultState()
    });

export default State;



// WEBPACK FOOTER //
// ./src/claim/labor-rate-change/state/index.js